module.exports = __webpack_public_path__ + "fb813310e0d700aa9744d0a17834ff3a.svg";